import React, { useContext, useEffect } from 'react'
import MainProducts from '../MainProducts/MainProducts'
import { fetchDataFromApi } from '../../utils/api';
import { Context } from '../../utils/context';
import { Link } from 'react-router-dom';
import whatsappLogo from "../../assets/whatsapp.jpg"

const DisplayProducts = () => {
    const {mainProduct,setMainProduct} = useContext(Context)
    useEffect(() => {
        getMainProducts();
    },[]);

    const getMainProducts = () => {
        fetchDataFromApi("/api/mainproducts?populate=*")
        .then((res) => {
            console.log(res);
            setMainProduct(res);
        })
    }
  return (
    <div>
      <div>
      <MainProducts mainProduct={mainProduct} headingText= "Products" />
      <div style={{width:"40px",height:"40px",position:"fixed",right:"10px",bottom:"10px",float:"right"}}>
                    <Link to="https://wa.me/919653217981">
        <img src={whatsappLogo}  style={{width:"60px", border:"1px solid white", borderRadius:"50%",cursor:"pointer" }} alt="" />
                    </Link>
                </div>

      </div>
    </div>
  )
}

export default DisplayProducts
